/** product builder **/

var productBuilder = new function() {

  var settings = {
    toggleBuilder : '[data-product-builder-toggle]',
    builder : '[data-product-builder]',
    input : '[data-gravure-input]',
    text : '[data-gravure-text]',
    addToCart : '[data-gravure-add]',
  };

  function productBuilder() {
    $(function(){
        if($('option[value="Avec gravure"][selected="selected"]').length > 0){
          // Si l'option par défaut est avec gravure, on force l'ouverture du volet
          openBuilder();
          setTimeout(function(){openBuilder();},1000);
        }
    });
    $(settings.toggleBuilder).on('click', function() {
      toggleBuilder();
    });
  }

  function openBuilder() {
    if ($('[data-product-builder-gravure]').length > 0) {
      if ($('input[value="Avec gravure"]').is(":disabled") && $('.product-builder-only').length == 0) {
        alert("Ce produit n'est plus disponible en gravure.");
        return false;
      }
    }
    $(settings.builder).addClass('active');
    $(settings.toggleBuilder).addClass('active');
    $(settings.addToCart).prop("type", "button");
    $(settings.text).removeClass('hide');
    $(settings.input).focus();
    pixelToVW(settings.text);
  }

  function closeBuilder() {
    $(settings.builder).removeClass('active');
    $(settings.toggleBuilder).removeClass('active');
    $(settings.addToCart).prop("type", "submit");
    $(settings.input).val("");
    $(settings.text).text("");
    $(settings.text).addClass('hide');
  }

  function toggleBuilder() {
    if ($(settings.builder).hasClass('active')) {
      closeBuilder();
    }
    else {
      openBuilder();
    }
  }

  function pixelToVW(element) {
    if (window.innerWidth > 720){

      var elems = document.querySelectorAll(element);

      elems.forEach(function(elem) {
        if (elem.getAttribute('data-font-size')) {
          var value = parseInt(elem.getAttribute('data-font-size'));
          var fontSize = (100 * value) / 1920;
          elem.style.fontSize = fontSize + "vw";
        }
      });
    }
  }

  $(settings.addToCart).on('click', function() {
    if ($(settings.toggleBuilder).hasClass('active') && !$(settings.input).val()) {
      $('[data-product-builder-error]').show();
    }
  });

  $(settings.input).on('keyup change', function() {
    if ($(this).val()) {
      $(settings.addToCart).prop("type", "submit");

      if ($(this).hasClass("uppercase")) {
        $(this).val($(this).val().toUpperCase());
      }
    } else {
      $(settings.addToCart).prop("type", "button");
    }
    $(settings.text).text($(this).val());
  });
  
  return productBuilder;
}

productBuilder();